import { createTheme } from "@mantine/core"

export const theme = createTheme({
  autoContrast: true,
  colors: {
    theaRed: [
      "#ffe9f2",
      "#fed2e0",
      "#f7a4bd",
      "#f17299",
      "#ec497a",
      "#ea2f66",
      "#ea205c",
      "#d0134d",
      "#bb0943",
      "#a4003a",
    ],
  },
  components: {
    Input: {
      styles: () => ({
        input: {
          fontSize: 16,
        },
      }),
    },
  },
  breakpoints: {
    xxl: "106em",
    xxxl: "125em",
  },
})
